import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL;

export default {
    getAccountSetting(token) {
        var accountUrl =  RESOURCE_NAME +  'user/account/settings';        
        return Axios.get(`${accountUrl}`);
    },
    updateAccountSetting(data, token) {
        var accountUrl =  RESOURCE_NAME +  'user/personal-info';
        return Axios.post(`${accountUrl}`, data);
    },
    changePassword(data, token) {
        var passwordUrl =  RESOURCE_NAME +  'user/change-password';
        return Axios.post(`${passwordUrl}`, data);
    },
    getNotificationEmail(customerId, token) {
        var notificationEmailUrl = OrderCircle_CONFIG.API_URL + 'account-settings/'+ customerId+'/notifications-emails' ;
        return Axios.get(`${notificationEmailUrl}`);
    },
    addNotificationEmail(data, token){
        var accountUrl =  RESOURCE_NAME +  'account-settings/notification-emails';
        return Axios.post(`${accountUrl}`, data);
    },
    deleteNotificationEmail(emailId, customerId, token){
        var accountUrl =  RESOURCE_NAME +  'account-settings/notification-emails/' + emailId + '/customer/' + customerId;
        return Axios.delete(`${accountUrl}`);
    }
};
